<div class="d-flex my16 align-items-center">
  <div class="f-gr-1">
    <span class="f18" i18n>User list</span>
    <div class="w25 mt16">
      <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
      </form>
    </div>
  </div>

  <button [disabled]="!organization?.ipAddress"
          (click)="openDetail()"
          mat-raised-button color="primary" i18n>
    Add client
  </button>
</div>

<div class="container">
  <table mat-table [dataSource]="dataSource" matSort>


    <ng-container matColumnDef="num">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>№</th>
      <td mat-cell *matCellDef="let row; let i = index"> {{i + 1}} </td>
    </ng-container>


    <ng-container matColumnDef="fio">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>FIO</th>
      <td mat-cell *matCellDef="let row">
        {{row.surname}} {{row.name}} {{row.fathers_name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="login">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Login</th>
      <td mat-cell *matCellDef="let row"> {{row.login}} </td>
    </ng-container>


    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Phone</th>
      <td mat-cell *matCellDef="let row"> {{row.phone}} </td>
    </ng-container>


    <ng-container matColumnDef="filial">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Filial</th>
      <td mat-cell *matCellDef="let row"> {{row.filial_id| json}} </td>
    </ng-container>

    <ng-container matColumnDef="dateCreation">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Date Creation</th>
      <td mat-cell *matCellDef="let row"> {{row.creation_date| date}} </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr class="pointer" (click)="openDetail(row)" mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>


</div>
